import { type MouseEventHandler } from 'react';
import SearchIcon from 'assets/icons/search.svg';
import styles from './search-item.module.scss';

const SearchItem = ({
	handleClick,
}: {
	handleClick: MouseEventHandler<HTMLButtonElement>;
}) => {
	return (
		<li className={styles.searchItem}>
			<button
				className={styles.button}
				onClick={handleClick}
				type="button"
				title="Open the search box"
				aria-label="Open the search box"
			>
				<SearchIcon data-testid="search-icon" aria-hidden="true" />
			</button>
		</li>
	);
};

export { SearchItem };
